<h2 mat-dialog-title>Doubles Name</h2>

<mat-dialog-content>

   <p>Enter your new Team Name:</p>
   <input type="text" style="width: 100%;" maxlength="30" [(ngModel)]="teamName" />
</mat-dialog-content>

<mat-dialog-actions style="float: right;">
   <a href="#" (click)="cancel()">Cancel</a>
   &nbsp;&nbsp;
   <button class="" (click)="save()">Save</button>
</mat-dialog-actions>